import { render, staticRenderFns } from "./TrackingChinesePage.vue?vue&type=template&id=a14463e8&scoped=true"
import script from "./TrackingChinesePage.vue?vue&type=script&lang=js"
export * from "./TrackingChinesePage.vue?vue&type=script&lang=js"
import style0 from "./TrackingChinesePage.vue?vue&type=style&index=0&id=a14463e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14463e8",
  null
  
)

export default component.exports